import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    DELETE_QUALIFICATION_TYPE: (id) => ({ id }),
    API: {
      DELETE_QUALIFICATION_TYPE: apiResourceActionCreator('qualificationType')
    }
  }
})

export const apiAction = (authToken, qualificationTypeId) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/qualification-type/${qualificationTypeId}`, authToken, actions.admin.api.deleteQualificationType);

function* deleteQualificationType(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.id));

  const result = yield apiActionResult(actions.admin.api.deleteQualificationType);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.qualificationType }));
  }
}

const configuration = {
  name: 'deleteQualificationType',
  action: actions,
  sagas: deleteQualificationType,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/deleteQualificationType.js